__webpack_require__.p = "/wp-content/plugins/hsf012_forms/";